<template>
    <a-drawer title="" :width="windowWidth" placement="right" @close="onClose" :visible="visible">
    <!-- <b-modal id="user-group-modal" size="xl"> -->
        <!-- <template slot="modal-header" slot-scope="{ close }"> -->
        <div class="row">
            <a-steps :current="current" class="col-md-8">
                <a-step v-for="item in steps" :key="item.title" :title="item.title" :description="item.description"/>
            </a-steps>
        </div>
        <!-- <button type="button" class="close" data-dismiss="modal" @click="close()"> &times;</button> -->
        <!-- </template> -->
        <br/><br/>
        <template style="width: 100vh;">
                <div v-if="current == 0" class="col-md-5 p-4">
                    <h2>User Group Info</h2>
                    <p>Enter the required information below to create a unique identifier for this user group.</p>
                    <br>
                    <base-input v-if="serverType == 'ho' && viewMode == false" alternative="" label="User Group Name" placeholder="e.g. admin" v-model="inputUserGroupName" input-classes="form-control"/>
                    <!-- <base-input v-if="serverType == 'ho' && viewMode == false" alternative="" label="User Group Code"  v-model="inputUserGroupName" input-classes="form-control"/> -->
                    <base-input v-else-if="(serverType == 'ho' && viewMode == true) || serverType == 'branch'" alternative="" label="User Group Name" placeholder="e.g. admin" v-model="inputUserGroupName" input-classes="form-control" disabled/>

                    <base-input label="Receive Email Notifications">
                        <!-- <a-select
                            v-model:value="selected_document_type"
                            mode="multiple"
                            style="width: 100%"
                            placeholder="Document type"
                            option-label-prop="label"
                            :disabled="serverType == 'ho' && viewMode == true"
                            >
                            <a-select-option v-for="item in documentTypeOptions" :key="item.key" :value="item.key"  :label="item.value">
                                <span>{{item.value}}</span>
                            </a-select-option>
                        </a-select> -->
                        <base-checkbox class="mb-3" v-model="emailNotifications.OTHTOV"
                                >Transfer Order Verification</base-checkbox>
                        <base-checkbox class="mb-3" v-model="emailNotifications.OTHPCV"
                                >Physical Count Verification</base-checkbox>
                    </base-input>

                </div>

                <div v-if="current == 1" class="row no-gutters px-4">
                    <!-- <div class="col-md-12">{{this.toPushData}}</div> -->

                    <div class="col-md-3" style="border-right: 1px solid #e0e0e0; height: 100vh;">
                        <div class="user-group-header pt-3 pr-2">
                            <a-input class="mb-1" placeholder="Search Categories" @change="onChange" />
                        </div>
                        <a-tree :show-line="true" class="tree" :defaultExpandedKeys="expandedKeys" :expandedKeys="expandedKeys"
                        :autoExpandParent="autoExpandParent" @expand="onExpand" @select="onSelect"
                        :treeData="gData">
                            <template slot="title" slot-scope="{title}">
                            <span v-if="title.indexOf(searchValue) > -1">
                                {{title.substr(0, title.indexOf(searchValue))}}
                                <span style="color: #f50">{{searchValue}}</span>
                                {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
                            </span>
                            <span v-else>{{title}} </span>
                            </template>
                        </a-tree>
                    </div>

                    <div class="col-md-3" style="border-right: 1px solid #e0e0e0; height: 100vh;">
                        <div class="user-group-header pt-3 pr-2">
                            <h3 class="pl-2 pb-1">Modules {{ (selectedTitle) ? (" - " + this.selectedTitle) : "" }}</h3>
                        </div>
                        <ul v-if="system_modules.length > 0" class="list-group list-group-flush" style="width: 100%">
                            <template v-for="system_module in system_modules" >
                                <li class="list-group-item" style="font-size: 14px;" :key="system_module.id" >
                                    <!-- :class="[{selected2: selectedModule.id == system_module.id}]" -->
                                    <div class="row" @click.prevent="selectModule(system_module)">
                                        <div class="col-md-12">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{system_module.name}}
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>

                        <!-- <ul v-if="system_modules.length > 0" class="list-group list-group-flush pl-3 py-2" style="width: 100%">
                            <div v-for="system_module in system_modules" :key="system_module.id">
                                <b-link id="module-link" @click="selectModule(system_module)">{{system_module.name}}</b-link>
                            </div>
                        </ul> -->
                        <div v-else class="p-3">
                            <small>No modules to display</small>
                        </div>
                    </div>

                    <div class="col-md-3" style="border-right: 1px solid #e0e0e0; height: 100vh;">
                        <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7; border-radius: 0px; border-style: solid; border-width: 0px 0px 2px 0px;">
                            <div class="row" >
                                <div class="col">
                                    <!-- {{selectedNode}} -->
                                    <h3 class="text-truncate">Access Rights {{ (selectedModule) ? (" - " + this.selectedModule.name) : "" }}</h3>
                                </div>
                                <div class="col-1" v-if="selectedNode != null || selectedNode != undefined">
                                    <div  v-if="!selectedNode.scopedSlots.code.includes('POS-PO')">
                                        <a-checkbox v-if="(system_modules.length > 0) && (selectedModule != null) && serverType == 'ho'" @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == selectedModule.supported_rights.split(',').length" class="float-right" :disabled='viewMode != false' />
                                        <a-checkbox v-else-if="(system_modules.length > 0) && (selectedModule != null)" @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == selectedModule.supported_rights.split(',').length" class="float-right" disabled/>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <ul v-if="system_modules.length > 0" class="list-group list-group-flush" style="width: 100%">
                            <ul v-if="selectedModule != null" class="list-group list-group-flush" style="width: 100%">
                                <template v-for="accessRight in accessRights">
                                    <li class="list-group-item" style="font-size: 14px; background-color: #f7f7f7;" v-if="selectedModule.supported_rights.split(',').includes(accessRight.key)" :key="accessRight.key">
                                        <div class="row" >
                                            <div class="col-md-6">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{accessRight.name}}
                                            </div>
                                            <div class="col-md-6">
                                                <a-checkbox v-if="serverType == 'ho' && viewMode == false" data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right"/>
                                                <a-checkbox v-else-if="(serverType == 'ho' && viewMode == true) || serverType == 'branch'" data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right" disabled/>
                                            </div>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                            <ul v-else class="list-group list-group-flush p-3" style="width: 100%">
                               <small>No access rights to display</small>
                            </ul>
                        </ul>
                        <ul v-else class="list-group list-group-flush p-3" style="width: 100%">
                            <small>No access rights to display</small>
                        </ul>

                        <br/><br/>
                        <div v-if="selectedNode != null || selectedNode != undefined">
                            <li v-if="selectedNode.scopedSlots.code.includes('POS-PO')" class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7; border-radius: 0px; border-style: solid; border-width: 0px 0px 2px 0px;">
                                <div class="row" >
                                    <div class="col">
                                        <h3 class="text-truncate">Other Settings</h3>
                                    </div>
                                </div>
                            </li>
                            <ul v-if="system_modules.length > 0" class="list-group list-group-flush" style="width: 100%">
                                <ul v-if="selectedModule != null" class="list-group list-group-flush" style="width: 100%">
                                    <!-- <template v-for="accessRight in accessRights"> -->
                                    <li class="list-group-item" style="font-size: 14px; background-color: #f7f7f7;">
                                        <div class="row" >
                                            <div class="col-md-6">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Require Reason
                                            </div>
                                            <div class="col-md-6">
                                                <a-checkbox v-if="serverType == 'ho' && viewMode == false" data-id="system_module.name" @change="onCheckChangeReqs(1)" :checked="requireReason" class="float-right"/>
                                                <!-- <a-checkbox v-if="serverType == 'ho' && viewMode == false" data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right"/>
                                                <a-checkbox v-else-if="(serverType == 'ho' && viewMode == true) || serverType == 'branch'" data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right" disabled/> -->
                                            </div>
                                        </div>
                                    </li>
                                    <li class="list-group-item" style="font-size: 14px; background-color: #f7f7f7;">
                                        <div class="row" >
                                            <div class="col-md-6">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Require Remarks
                                            </div>
                                            <div class="col-md-6">
                                                <a-checkbox v-if="serverType == 'ho' && viewMode == false" data-id="system_module.name" @change="onCheckChangeReqs(2)" :checked="requireRemarks" class="float-right"/>
                                                <!-- <a-checkbox v-if="serverType == 'ho' && viewMode == false" data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right"/>
                                                <a-checkbox v-else-if="(serverType == 'ho' && viewMode == true) || serverType == 'branch'" data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right" disabled/> -->
                                            </div>
                                        </div>
                                    </li>
                                    <!-- </template> -->
                                </ul>
                            </ul>
                        </div>

                    </div>


                    <div class="col-md-3" style="height: 100vh;" v-if="selectedAccessRights.includes('S') && selectedNode.scopedSlots.code.includes('POS-PO')">
                        <li class="list-group-item" style="font-size: 14px; height: 55px; border-radius: 0px; border-style: solid; border-width: 0px 0px 2px 0px;">
                            <div class="row" >
                                <div class="col-md-11">
                                    <h3 class="text-truncate">Authorization Group</h3>
                                </div>
                            </div>
                        </li>

                        <ul class="list-group list-group-flush" style="width: 100%">
                            <template v-for="userGroup in userGroups" >
                                <li class="list-group-item" style="font-size: 14px;" :key="userGroup.id" v-if="userGroup.id != profileId">
                                    <div class="row">
                                        <div class="col-md-6">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{userGroup.name}}
                                        </div>
                                        <div class="col-md-6">
                                            <a-checkbox v-if="serverType == 'ho' && viewMode == false" data-id="userGroup.id" @change="onCheckChangeAccessGroup(userGroup.id.toString())" :checked="selectedGroups.includes(userGroup.id.toString())" class="float-right"/>
                                            <!-- <a-checkbox v-else-if="(serverType == 'ho' && viewMode == true) || serverType == 'branch'" data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right" disabled/> -->
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>

        </template>
        <!-- <template slot="modal-footer" slot-scope="{cancel}"> -->
            <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                <div class="container mx-0 px-0">
                    <div class="row">
                        <div class="col-auto mr-auto">
                            <b-button size="sm" class='float-md-left' style="margin-left: 8px" @click="onClose()">
                                Cancel
                            </b-button>
                        </div>
                        <div class="col-auto">

                            <template v-if="current < steps.length - 1">
                                <b-button size="sm"  variant="primary" @click="nextUserGroupStep">
                                    Next
                                </b-button>
                            </template>
                            <template v-if="current>0">
                                <b-button size="sm"  style="margin-left: 8px" @click="prevUserGroupStep" >
                                    Previous
                                </b-button>
                            </template>
                            <template v-if="current == steps.length - 1 && serverType == 'ho'">
                                <b-button v-if="(profileId == 0)" size="sm" variant="primary" @click.prevent="create">
                                    Create Group
                                </b-button>
                                <b-button v-else size="sm" variant="primary" @click.prevent="update" :disabled="viewMode != false">
                                    Save
                                </b-button>
                            </template>
                            <template v-else-if="current == steps.length - 1">
                                <b-button v-if="(profileId == 0)" size="sm" variant="primary" @click.prevent="create" disabled>
                                    Create Group
                                </b-button>
                                <b-button v-else size="sm" variant="primary" @click.prevent="update" disabled>
                                    Save
                                </b-button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

        <!-- </template> -->
    <!-- </b-modal> -->
    </a-drawer>
</template>
<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import moment from "moment"
let gData = []
const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: node.title })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}

const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}

let node_ret = null
const getNode = function (key, tree)
{
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if(node.key == key){
       node_ret = node
    } else {
        if(node.children.length > 0){
            getNode(key, node.children)
        }
    }
  }
  return node_ret;
}

import { mapState, mapActions } from 'vuex'
import secureStorage from '../../controllers/secureStorage.js'

var component_x;
export default {
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'profileId', 'serverType']),
    },
    mounted: async function() {
       component_x = this
       this.viewMode = this.$attrs.viewMode
        this.gData = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/enabled_tree_view', null)
        gData = this.gData
        generateList(gData)
        var document_types = await HTTPRequest.getRequest(this.endPoint + 'document_types/get_valid_document_types', null)
        this.documentTypeOptions = document_types
        if( component_x.profileId > 0){
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'user_groups/' + component_x.profileId, null)
            var permissions =await HTTPRequest.getRequest(this.endPoint + '/user_group_permissions?user_group_id=' + component_x.profileId, null)
            if(data == undefined){
                component_x.$router.go()
            } else {
                if(data["error"] == undefined){
                    component_x.inputUserGroupName = data["name"]
                    //component_x.selected_document_type = ((data["email_document_types"] != null) ? data["email_document_types"].split(',') : [])
                    if(data["email_document_types"] != null){
                        component_x.emailNotifications = data["email_document_types"]
                    }
                    if(data["name"] == "Admin")
                        component_x.viewMode = true
                    this.savedAccessRights = permissions.data
                } else {
                    this.errors = data["error"].split(",")
                }
            }
        }

        this.userGroups = await HTTPRequest.getRequest(component_x.endPoint + 'user_groups/get_all_user_groups', null)
        this.visible = this.$attrs.visible;
        this.$nextTick(function() { //for fullscreen drawer
          window.addEventListener('resize', this.getWindowWidth);
          this.getWindowWidth()
        })

    },
    data: function(){
        return {
            emailNotifications:{
                OTHTOV: false,
                OTHPCV: false
            },
            documentTypeOptions: [],
            selected_document_type: [],
            requireRemarks: false,
            requireReason: false,
            selectedGroups: [],
            windowWidth: 0,
            groupId: 0,
            viewMode: false,
            savedAccessRights: [],
            filterStatus: "",
            selectedModule: null,
            system_modules: [],
            module:{
                name: "",
                code: "",
                reference_code: "",
                supported_rights: ""
            },
            checkedValues: [],
            expandedKeys: [],
            searchValue: '',
            autoExpandParent: true,
            gData,
            visible: false,
            formId: "",
            selectedNode: null,
            selectedKey: null,
            selectedTitle: "",
            selectedCode: "",
            selectedRefCode: "",
            accessRights: [ {name: 'View', key:'V'}, {name: 'Add', key: 'A'}, {name: 'Edit', key: 'W'}, {name: 'Delete', key: 'D'},
                            {name: 'Post', key: 'P'}, {name: 'Confirm', key: 'C'}, {name: 'Print', key: 'T'},
                            {name: 'With Supervision', key: 'S'}, {name: 'Sensitive Info', key: 'X'},
                            {name: 'Access Cost', key: 'Z'}, {name: 'Access Price', key: 'Y'}, {name: 'Import', key: 'I'}, {name: 'Export', key: 'E'},
                            {name: 'Scan', key: 'N'}, {name: 'Download', key: 'Q'}, {name: 'Wipe Data', key: 'R'}, {name: 'Configure', key: 'G'}], //12
            selectedAccessRights: [],
            selectedProfile: "system_modules",
            errors: [],
            inputUserGroupName: '',
            current: 0,
            steps: [{
                title: 'User Group Info',
                description: 'Add User Group Name'
            }, {
                title: 'Access Rights',
                description: 'Manage Rights for this Group'
            }],
            toPushData: [],
            userGroups: [],
        }
    },
    methods: {
         moment,
        ...mapActions(['updateCurrentProfile', 'updateParameters']),
        create: async function() {
            var index = this.toPushData.findIndex(x => x.system_module_id == this.selectedModule.id);

            if (index < 0){
                if (this.selectedAccessRights.length > 0 ) this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(','), auth_groups: this.selectedGroups.join(','), require_reason: this.requireReason, require_remarks: this.requireRemarks});
            } else {
                if (this.selectedAccessRights.length > 0 ){
                    this.toPushData[index].access_right = this.selectedAccessRights.join(',')
                    this.toPushData[index].auth_groups = this.selectedGroups.join(',')
                    this.toPushData[index].require_reason = this.requireReason
                    this.toPushData[index].require_remarks = this.requireRemarks
                } else {
                    this.toPushData.splice(index,1);
                }
            }
            var userGroupPayload = {user_group: {name: this.inputUserGroupName
                                    , user_group_permissions: JSON.parse(JSON.stringify(this.toPushData))
                                    , email_document_types: JSON.parse(JSON.stringify(this.emailNotifications))
                                    }
                                }
            
            // console.log(">>>>Processing>>>>")
            var post_request = await HTTPRequest.postRequest(this.endPoint + 'user_groups', null, userGroupPayload)
            this.groupId = post_request.id
            this.create_action_history("Create")

            // console.log(">>>>>>>>")
            // console.log(post_request)

            if(post_request == undefined){
                this.$emit('refreshPage', event)
            } else {
                // console.log("POST REQUEST IS DEFINED")
                // console.log(post_request["error"])
                if(post_request["error"] == undefined){
                    this.$emit('refreshPage', event)
                    this.$root.$emit('bv::hide::modal', 'user-group-modal')
                } else {
                    this.errors = post_request["error"].split(",")
                    this.$notification['error']({
                        message: 'User Group Creation Error',
                        description: "Error: " + this.errors
                    }); 
                }
            }
            this.visible = false
        },
        update: async function(){
            var index = this.toPushData.findIndex(x => x.system_module_id == this.selectedModule.id);
            if (index < 0){
                if (this.selectedModule && this.selectedAccessRights && this.selectedGroups) {
                    this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(','), auth_groups: this.selectedGroups.join(','), require_reason: this.requireReason, require_remarks: this.requireRemarks});
                }
            } else {
                if (this.selectedAccessRights.length > 0 ){
                    this.toPushData[index].access_right = this.selectedAccessRights.join(',')
                    this.toPushData[index].auth_groups = this.selectedGroups.join(',')
                    this.toPushData[index].require_reason = this.requireReason
                    this.toPushData[index].require_remarks = this.requireRemarks
                 } else {
                    this.toPushData.splice(index,1);
                 }
            }
            var userGroupPayload = {user_group: {id: this.profileId, name: this.inputUserGroupName
                                    , user_group_permissions: JSON.parse(JSON.stringify(this.toPushData))
                                    , email_document_types: JSON.parse(JSON.stringify(this.emailNotifications))
                                    }
                                }
            var put_request = await HTTPRequest.putRequest(this.endPoint + 'user_groups/' + this.profileId, null, userGroupPayload)
            // this.create_action_history("Update")
            if(put_request == undefined){
                this.$emit('refreshPage', event)
            } else {
                if(put_request["error"] == undefined){
                    this.$emit('refreshPage', event)
                    this.$root.$emit('bv::hide::modal', 'user-group-modal')
                } else {
                   this.errors = put_request["error"].split(",")
                }
            }
            this.visible = false
        },
        async create_action_history(action) {
            var id = 0
            if(this.groupId > 0){
                id = this.groupId
            }else{
                id = this.profileId
            }
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                group_id: id,
                status: "A"
            }
            var res = await HTTPRequest.postRequest(this.endPoint + 'user_group_action_histories/', null, actionHistoryPayload)
        },
        nextUserGroupStep() {
            this.current++
        },
        prevUserGroupStep() {
            this.current--
        },
        //CHECKBOX SYSTEM ACCESS
        onCheckChangeAccess(e){
            if(this.selectedNode.scopedSlots.code.includes("POS-PO")){
                if(this.selectedAccessRights.includes(e)){
                    var indexValue = this.selectedAccessRights.indexOf(e)
                    this.selectedAccessRights.splice(indexValue,1)
                } else {
                    if(this.selectedAccessRights.length > 0){
                        this.selectedAccessRights = []
                        this.selectedAccessRights.push(e)
                    }else {
                        this.selectedAccessRights.push(e)
                    }
                }
            } else {
                if(this.selectedAccessRights.includes(e)){
                    var indexValue = this.selectedAccessRights.indexOf(e)
                    this.selectedAccessRights.splice(indexValue,1)
                } else {
                    this.selectedAccessRights.push(e)
                }
            }

        },
        // CHECKBOX USER GROUP
        onCheckChangeAccessGroup(e){
            if(this.selectedGroups.includes(e)){
                var indexValue = this.selectedGroups.indexOf(e)
                this.selectedGroups.splice(indexValue,1)
            } else {
                this.selectedGroups.push(e)
            }
        },

        // Require Reason/Remarks
        onCheckChangeReqs(e){
            if(e == 1){
                this.requireReason = !this.requireReason
                // console.log(`Reason :: ${this.requireReason}`)
            }else{
                this.requireRemarks = !this.requireRemarks
                // console.log(`Remarks :: ${this.requireRemarks}`)
            }
        },

        // STEPS
        onCheckAllChangeAccess(){
            if(this.selectedAccessRights.length == this.selectedModule.supported_rights.split(',').length){
                this.selectedAccessRights = []
            } else {
                this.selectedAccessRights = this.selectedModule.supported_rights.split(',')
            }
        },

        // TREE FUNCTIONS
        onExpand  (expandedKeys) {
            this.selectedNode = null
            this.expandedKeys = expandedKeys
            this.autoExpandParent = false
        },
        onChange (e) {
            const value = e.target.value
            const expandedKeys = dataList.map((item) => {
                if (item.title.indexOf(value) > -1) {
                    return getParentKey(item.key, gData)
                }
                return null
            }).filter((item, i, self) => item && self.indexOf(item) === i)
            Object.assign(this, {
                expandedKeys,
                searchValue: value,
                autoExpandParent: true,
            })
        },
        async onSelect(info){
            // console.log("---- ON SELECT")
            var selectedNode = getNode(info[0], gData)
            this.selectedNode = selectedNode
            this.selectedKey = selectedNode.key
            this.selectedCode = selectedNode.scopedSlots.code
            this.selectedRefCode = selectedNode.scopedSlots.reference_code
            this.selectedTitle = selectedNode.title
            this.checkedValues = []

            if(selectedNode.children.length == 0){
                var system_modules = await HTTPRequest.getRequest(this.endPoint + '/system_modules?system_module_category_id=' + this.selectedKey + "&enabled=1&status=A" , null)
                this.system_modules = system_modules
                // this.selectedModule = this.system_modules[0]
            } else {
                this.system_modules = []
            }

            if(this.selectedModule != null) {
                if(this.toPushData.length == 0){
                    if (this.selectedAccessRights.length > 0 ) this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(','), auth_groups: this.selectedGroups.join(','), require_reason: this.requireReason, require_remarks: this.requireRemarks});
                } else {
                    var index = this.toPushData.findIndex(x => x.system_module_id == this.selectedModule.id);
                    if (index < 0){
                        if (this.selectedAccessRights.length > 0 ) this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(','),  auth_groups: this.selectedGroups.join(','), require_reason: this.requireReason, require_remarks: this.requireRemarks});
                    } else {
                        if (this.selectedAccessRights.length > 0 ){
                            this.toPushData[index].access_right = this.selectedAccessRights.join(',')
                            this.toPushData[index].auth_groups = this.selectedGroups.join(',')
                        } else {
                            this.toPushData.splice(index,1);
                        }
                    }
                }
                this.selectedModule = null;
                this.selectedAccessRights = [];
                this.selectedGroups = [];
                this.requireRemarks = false;
                this.requireReason = false;
            }
        },
        selectModule(system_module) {
            // console.log("---- SELECT MODULE")
            if(this.selectedModule != null) {
                if(this.toPushData.length == 0){
                    // console.log("---- PUSH DATA == 0")
                    // console.log(this.selectedGroups)
                    // console.log(this.selectedAccessRights)
                    if(this.selectedNode.scopedSlots.code.includes("POS-PO")){
                        // console.log("---- POS SYSTEM MODULE")
                        if (this.selectedAccessRights.length >= 0  && this.selectedGroups.length >= 0 ) this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(','), auth_groups: this.selectedGroups.join(','), require_reason: this.requireReason, require_remarks: this.requireRemarks});
                    } else {
                        // console.log("---- MMS SYSTEM MODULE")
                        if (this.selectedAccessRights.length >= 0 ) this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(',')});
                    }
                } else {
                    // console.log("---- PUSH DATA > 0")
                    if(this.selectedNode.scopedSlots.code.includes("POS-PO")){
                        // console.log("---- POS SYSTEM MODULE")
                        var index = this.toPushData.findIndex(x => x.system_module_id == this.selectedModule.id);
                        if (index < 0){
                            if (this.selectedGroups.length >= 0 ) this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(','), auth_groups: this.selectedGroups.join(','), require_reason: this.requireReason, require_remarks: this.requireRemarks});
                        } else {
                            if (this.selectedGroups.length > 0 ){
                                this.toPushData[index].access_right = this.selectedAccessRights.join(',')
                                this.toPushData[index].auth_groups = this.selectedGroups.join(',')
                            } else {
                                this.toPushData.splice(index,1);
                            }
                        }
                    } else {
                        // console.log("---- MMS SYSTEM MODULE")
                        var index = this.toPushData.findIndex(x => x.system_module_id == this.selectedModule.id);
                        if (index < 0){
                            if (this.selectedAccessRights.length >= 0 ) this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(',')});
                            // if (this.selectedGroups.length >= 0 ) this.toPushData.push({system_module_id: this.selectedModule.id, system_module_code: this.selectedModule.code, access_right: this.selectedAccessRights.join(','), auth_groups: this.selectedGroups.join(',')});
                        } else {
                            if (this.selectedAccessRights.length > 0 ){
                                this.toPushData[index].access_right = this.selectedAccessRights.join(',')
                                // this.toPushData[index].auth_groups = this.selectedGroups.join(',')
                            } else {
                                this.toPushData.splice(index,1);
                            }
                        }
                    }
                }
                this.selectedAccessRights = [];
                this.selectedGroups = [];
                this.requireRemarks = false;
                this.requireReason = false;
            }

            this.selectedModule = system_module;
            var currentModuleAccessRights = this.toPushData.find(x => x.system_module_id == this.selectedModule.id);
            if (currentModuleAccessRights) {
                // console.log("---- CURRENT MODULE ACCESS RIGHTS")
                // console.log(currentModuleAccessRights)
                this.selectedAccessRights = currentModuleAccessRights.access_right.split(',');
                if(currentModuleAccessRights.auth_groups  != null){
                    // console.log("---- MUST ASSIGN SELECTED GROUPS")
                    this.selectedGroups = currentModuleAccessRights.auth_groups.split(',')
                }
                this.requireRemarks = currentModuleAccessRights.require_remarks
                this.requireReason = currentModuleAccessRights.require_reason
            } else {
                // console.log("---- NO CURRENT MODULE ACCESS RIGHTS")
                var hasSavedAccessRights = this.savedAccessRights.find(x => x.system_module_id == this.selectedModule.id)
                if (hasSavedAccessRights){
                    this.selectedAccessRights = hasSavedAccessRights.access_right.split(',')
                    if(hasSavedAccessRights.auth_groups  != null) this.selectedGroups = hasSavedAccessRights.auth_groups.split(',')
                    this.requireRemarks = hasSavedAccessRights.require_remarks
                    this.requireReason = hasSavedAccessRights.require_reason
                }
            }
        },
        async onDrop (info) {
            var for_update = info.dragNode.$options.propsData.eventKey
            var new_parent = info.node.$options.propsData.eventKey
            var categoryPayload = {system_module_category: {parent_id: new_parent} }
            this.gData = await HTTPRequest.putRequest(this.endPoint + '/system_module_categories/' + for_update , null, categoryPayload)
            gData = this.gData
            generateList(gData)
        },
        setCurrentProfile(profile){
            this.selectedProfile = profile
            if(profile == "terminals" || profile == "payment_types"){
                this.updateCurrentProfile(profile)
            }
        },
        changeFilter(statusFilter, searchFilter, searchText){
            this.filterStatus = statusFilter
            if(statusFilter == "0"){
                this.updateParameters("?" + searchFilter + "=" + searchText);
            } else if( statusFilter == "A"){
                this.updateParameters("?" + searchFilter + "=" + searchText + "&status=A");
            } else {
                this.updateParameters("?" + searchFilter + "=" + searchText + "&status=I");
            }
        },
        onClose(){
            this.visible = false
        },
        getWindowWidth(event) { //for fullscreen drawer
            this.windowWidth = window.innerWidth
        },

    }
}
</script>

<style>

.modal-body{
    /* background-color: #F7F7F7; */
    background-color: white;
    border-top: 2px solid #e0e0e0;
    border-bottom: 2px solid #e0e0e0;
}
.modal-body {
    margin: 0;
    padding: 0;
    /*padding-left: 80px;
    padding-right: 100px;*/
}

.ant-steps-item-process .ant-steps-item-icon {
    background: #65CB8F;
    border: #65CB8F;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
    white-space: nowrap;
    max-width: 100%;
}
.ant-steps-item-finish .ant-steps-item-icon {
    border-color: #AFB5BC;
    background-color: #fff;
}
.ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title:after {
    background-color: #AFB5BC;
}
.user-group-header {
    border-bottom: 1px solid #e0e0e0;
}

#module-link:hover {
    background-color: #BAE7FF;
    padding: 2px;
    border-radius: 3px;
}
#module-link {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    text-decoration: none;
    padding-left: 2px;
}

.selected2{
    background-color:  #EFF6FF;
    color: #2371CC;
}

</style>
